import { connect } from 'react-redux';
import { getTotalCost } from '../../containers/ticketSelection/utils/ticketPriceUtils';
import { getTotalSelectedTickets } from '../../containers/ticketSelection/utils/ticketUtils';
import { getLocaleProps } from '../../selectors/app';
import { getSelectedTickets } from '../../selectors/tickets';
import { CheckoutState } from '../../state';
import { isExpressCheckoutEnabled } from '../../utils/applePay';
import { ExpressCheckoutProps } from './ExpressCheckout';

const _mapStateToProps = (
    state: CheckoutState,
): Partial<ExpressCheckoutProps> => {
    const { applepay } = state;
    const selectedTickets = getSelectedTickets(state);
    return {
        applePay: applepay,
        isFreeOrder: getTotalCost(selectedTickets) === 0,
        totalTicketQuantity: getTotalSelectedTickets(selectedTickets),
        locale: getLocaleProps(state).defaultLocale,
        isExpressCheckout: isExpressCheckoutEnabled(state),
    };
};

export type ConnectedProps = ReturnType<typeof _mapStateToProps>;

export const connectExpressCheckout = connect(_mapStateToProps);
